// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip[data-v-255d503e]  .tooltip{background-color:rgba(0,0,0,.8);color:#fff;font-weight:600;line-height:1rem;padding:15px;max-width:300px;white-space:break-spaces}.tooltip[data-v-255d503e]  .menu-wrap{min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:auto}.tooltip[data-v-255d503e]  .arrow{display:none}", ""]);
// Exports
module.exports = exports;
